export default __webpack_public_path__ + "static/media/mobile.d948936c.svg";